<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      {{ $t("events.event-config.complementary-info") }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-row>
        <v-col cols="12">
          <BaseTextField
            required
            :label="$t('events.event-config.product-url')"
            :placeholder="$t('events.event-config.insert-product-url')"
            v-model="$produtos_gerenciar.cadastro.pre_visualizacao.slug"
            counter
            :maxlength="65"
            type="text"
            :rules="[rules.required, rules.max(65)]"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import mixins from "@/mixins";
import BaseTextField from "@/components/forms/BaseTextField.vue";

const { products, formRules } = mixins;

export default {
  name: "AdditionalInformation",
  mixins: [products, formRules],
  components: {
    BaseTextField,
  },
  watch: {
    "$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br"(e) {
      this.$produtos_gerenciar.cadastro.pre_visualizacao.slug =
        this.$produtos_gerenciar.transformToSlug(e);
    },
  },
};
</script>

<style scoped></style>
